module.exports = __webpack_public_path__ + "sl.svg?dcc4cc62337033857156fc59f15fe5e2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sl.svg
// module id = 1378
// module chunks = 27